// Maps an Okta OAuth redirect error (returned on the callback URL as
// `?error=<code>&error_description=<text>`) into a friendly, actionable message
// for the sign-in screen. Kept free of browser/`./api` imports so it can be unit
// tested under node:test without a DOM.

/** Turn an Okta `error` code + description into a human-readable message. */
export function describeOktaError(code: string, description: string | null): string {
  const desc = description?.trim() || null;
  if (code === "access_denied") {
    // The most common cause: the user authenticated but their Okta account is
    // not assigned to the Omni Hub application.
    if (!desc || /not assigned/i.test(desc)) {
      return "Your Okta account isn't assigned to Omni Hub. Ask an Okta administrator to grant you access to the Omni Hub application, then try again.";
    }
    return desc;
  }
  return desc || `Sign-in failed (${code}).`;
}
